import styles from '../CaseBuilderEnhanced.module.css';

const STATUS_CONFIG = {
    draft: { label: 'Draft', className: styles.badgeDraft },
    in_progress: { label: 'In progress', className: styles.badgeProgress },
    ready: { label: 'Ready', className: styles.badgeReady },
};

export default function CaseStatusChip({ status, quarantined = false }) {
    const config = STATUS_CONFIG[status] || STATUS_CONFIG.draft;
    return (
        <span className={styles.chipRow}>
            <span className={`${styles.badge} ${config.className}`}>{config.label}</span>
            {quarantined && (
                <span className={`${styles.badge} ${styles.badgeQuarantine}`} title="Not released to network">
                    Quarantined
                </span>
            )}
        </span>
    );
}
